// @file Helpers for approve all button state management
import { captureException } from '@@/bits/error_tracker'
import { asciiSafeStringify } from '@@/bits/json_stringify'
import { getSafeStorage } from '@@/bits/safe_storage'

const USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY = 'userClosedApproveAllButtonMap'
const safeStorage = getSafeStorage()

const isInClosedApproveAllButtonMap = (hashid: string): boolean => {
  try {
    const mapString = safeStorage.getItem(USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY) ?? '{}'
    return Boolean(JSON.parse(mapString)[hashid])
  } catch (err) {
    captureException(err, { tags: { source: 'isInClosedApproveAllButtonMap' } })
    safeStorage.setItem(USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY, '{}')
    return false
  }
}

const updateUserClosedApproveAllButtonMap = (hashid: string, value: boolean): void => {
  try {
    const mapString = safeStorage.getItem(USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY) ?? '{}'
    const parsedMap = JSON.parse(mapString)
    if (value) {
      parsedMap[hashid] = value
    } else {
      delete parsedMap[hashid]
    }
    safeStorage.setItem(USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY, asciiSafeStringify(parsedMap))
  } catch (err) {
    captureException(err, { tags: { source: 'updateUserClosedApproveAllButtonMap' } })
    safeStorage.setItem(USER_CLOSED_APPROVE_ALL_BUTTON_MAP_KEY, '{}')
  }
}

export { isInClosedApproveAllButtonMap, updateUserClosedApproveAllButtonMap }
